if (window.APP_CONFIG?.freshDeskLiveChat?.enabled) {
  (function () {
    let fc_CSS = document.createElement('link');
    fc_CSS.setAttribute('rel', 'stylesheet');
    let fc_isSecured = window.location && window.location.protocol == 'https:';
    let fc_lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    let fc_rtlLanguages = ['ar', 'he'];
    let fc_rtlSuffix = fc_rtlLanguages.indexOf(fc_lang) >= 0 ? '-rtl' : '';
    fc_CSS.setAttribute('type', 'text/css');
    fc_CSS.setAttribute(
      'href',
      (fc_isSecured
        ? 'https://d36mpcpuzc4ztk.cloudfront.net'
        : 'http://assets1.chat.freshdesk.com') +
        '/css/visitor' +
        fc_rtlSuffix +
        '.css',
    );
    document.getElementsByTagName('head')[0].appendChild(fc_CSS);
    let fc_JS = document.createElement('script');
    fc_JS.type = 'text/javascript';
    fc_JS.defer = true;
    fc_JS.src =
      (fc_isSecured
        ? 'https://d36mpcpuzc4ztk.cloudfront.net'
        : 'http://assets.chat.freshdesk.com') + '/js/visitor.js';
    (document.body
      ? document.body
      : document.getElementsByTagName('head')[0]
    ).appendChild(fc_JS);
    window.livechat_setting =
      'eyJ3aWRnZXRfc2l0ZV91cmwiOiJzdXBwb3J0Lmhvd2xlci5jby56YSIsInByb2R1Y3RfaWQiOjQwMDAwMDE4MTYsIm5hbWUiOiJIb3dsZXIgQ2FzaGxlc3MiLCJ3aWRnZXRfZXh0ZXJuYWxfaWQiOjQwMDAwMDE4MTYsIndpZGdldF9pZCI6Ijg5NWE0ZGQ2LWYyNGMtNGU3Ni1hZTQ2LWY1MmJiYTM2MTk5OCIsInNob3dfb25fcG9ydGFsIjp0cnVlLCJwb3J0YWxfbG9naW5fcmVxdWlyZWQiOmZhbHNlLCJsYW5ndWFnZSI6ImVuIiwidGltZXpvbmUiOiJBdGhlbnMiLCJpZCI6NDAwMDA1MzM1NywibWFpbl93aWRnZXQiOjAsImZjX2lkIjoiNzM0OGYzZDUwMWMwZDA4NDhiZTQ3ZWRiNzE3YzhmMmUiLCJzaG93IjoxLCJyZXF1aXJlZCI6MiwiaGVscGRlc2tuYW1lIjoiTnV0aWNrZXRzIFNBIiwibmFtZV9sYWJlbCI6Ik5hbWUiLCJtZXNzYWdlX2xhYmVsIjoiTWVzc2FnZSIsInBob25lX2xhYmVsIjoiUGhvbmUiLCJ0ZXh0ZmllbGRfbGFiZWwiOiJUZXh0ZmllbGQiLCJkcm9wZG93bl9sYWJlbCI6IkRyb3Bkb3duIiwid2VidXJsIjoibnV0aWNrZXRzc2EuZnJlc2hkZXNrLmNvbSIsIm5vZGV1cmwiOiJjaGF0LmZyZXNoZGVzay5jb20iLCJkZWJ1ZyI6MSwibWUiOiJNZSIsImV4cGlyeSI6MCwiZW52aXJvbm1lbnQiOiJwcm9kdWN0aW9uIiwiZW5kX2NoYXRfdGhhbmtfbXNnIjoiVGhhbmsgeW91ISEhIiwiZW5kX2NoYXRfZW5kX3RpdGxlIjoiRW5kIiwiZW5kX2NoYXRfY2FuY2VsX3RpdGxlIjoiQ2FuY2VsIiwic2l0ZV9pZCI6IjczNDhmM2Q1MDFjMGQwODQ4YmU0N2VkYjcxN2M4ZjJlIiwiYWN0aXZlIjoxLCJyb3V0aW5nIjpudWxsLCJwcmVjaGF0X2Zvcm0iOjEsImJ1c2luZXNzX2NhbGVuZGFyIjpudWxsLCJwcm9hY3RpdmVfY2hhdCI6MCwicHJvYWN0aXZlX3RpbWUiOjEwNSwic2l0ZV91cmwiOiJzdXBwb3J0Lmhvd2xlci5jby56YSIsImV4dGVybmFsX2lkIjo0MDAwMDAxODE2LCJkZWxldGVkIjowLCJtb2JpbGUiOjEsImFjY291bnRfaWQiOm51bGwsImNyZWF0ZWRfYXQiOiIyMDE3LTA4LTIzVDA3OjQ1OjM4LjAwMFoiLCJ1cGRhdGVkX2F0IjoiMjAxNy0wOC0yM1QxMzoyMTo0NC4wMDBaIiwiY2JEZWZhdWx0TWVzc2FnZXMiOnsiY29icm93c2luZ19zdGFydF9tc2ciOiJZb3VyIHNjcmVlbnNoYXJlIHNlc3Npb24gaGFzIHN0YXJ0ZWQiLCJjb2Jyb3dzaW5nX3N0b3BfbXNnIjoiWW91ciBzY3JlZW5zaGFyaW5nIHNlc3Npb24gaGFzIGVuZGVkIiwiY29icm93c2luZ19kZW55X21zZyI6IllvdXIgcmVxdWVzdCB3YXMgZGVjbGluZWQiLCJjb2Jyb3dzaW5nX2FnZW50X2J1c3kiOiJBZ2VudCBpcyBpbiBzY3JlZW4gc2hhcmUgc2Vzc2lvbiB3aXRoIGN1c3RvbWVyIiwiY29icm93c2luZ192aWV3aW5nX3NjcmVlbiI6IllvdSBhcmUgdmlld2luZyB0aGUgdmlzaXRvcuKAmXMgc2NyZWVuIiwiY29icm93c2luZ19jb250cm9sbGluZ19zY3JlZW4iOiJZb3UgaGF2ZSBhY2Nlc3MgdG8gdmlzaXRvcuKAmXMgc2NyZWVuLiIsImNvYnJvd3NpbmdfcmVxdWVzdF9jb250cm9sIjoiUmVxdWVzdCB2aXNpdG9yIGZvciBzY3JlZW4gYWNjZXNzICIsImNvYnJvd3NpbmdfZ2l2ZV92aXNpdG9yX2NvbnRyb2wiOiJHaXZlIGFjY2VzcyBiYWNrIHRvIHZpc2l0b3IgIiwiY29icm93c2luZ19zdG9wX3JlcXVlc3QiOiJFbmQgeW91ciBzY3JlZW5zaGFyaW5nIHNlc3Npb24gIiwiY29icm93c2luZ19yZXF1ZXN0X2NvbnRyb2xfcmVqZWN0ZWQiOiJZb3VyIHJlcXVlc3Qgd2FzIGRlY2xpbmVkICIsImNvYnJvd3NpbmdfY2FuY2VsX3Zpc2l0b3JfbXNnIjoiU2NyZWVuc2hhcmluZyBpcyBjdXJyZW50bHkgdW5hdmFpbGFibGUgIiwiY29icm93c2luZ19hZ2VudF9yZXF1ZXN0X2NvbnRyb2wiOiJBZ2VudCBpcyByZXF1ZXN0aW5nIGFjY2VzcyB0byB5b3VyIHNjcmVlbiAiLCJjYl92aWV3aW5nX3NjcmVlbl92aSI6IkFnZW50IGNhbiB2aWV3IHlvdXIgc2NyZWVuICIsImNiX2NvbnRyb2xsaW5nX3NjcmVlbl92aSI6IkFnZW50IGhhcyBhY2Nlc3MgdG8geW91ciBzY3JlZW4gIiwiY2Jfdmlld19tb2RlX3N1YnRleHQiOiJZb3VyIGFjY2VzcyB0byB0aGUgc2NyZWVuIGhhcyBiZWVuIHdpdGhkcmF3biAiLCJjYl9naXZlX2NvbnRyb2xfdmkiOiJBbGxvdyBhZ2VudCB0byBhY2Nlc3MgeW91ciBzY3JlZW4gIiwiY2JfdmlzaXRvcl9zZXNzaW9uX3JlcXVlc3QiOiJBZ2VudCBzZWVrcyBhY2Nlc3MgdG8geW91ciBzY3JlZW4gIn19';

    let chatLayout = null;
    let cbActions = null;
    const saveLiveChatElements = () => {
      const existingChatLayout = document.getElementById('lc_chat_layout');
      if (existingChatLayout) {
        chatLayout = existingChatLayout;
        chatLayout.remove();
      }
      const existingCbActions = document.getElementById('lc_cb_actions_vi');
      if (existingCbActions) {
        cbActions = existingCbActions;
        cbActions.remove();
      }
    };

    const restoreLiveChatElements = () => {
      if (chatLayout) {
        const existingChatLayout = document.getElementById('lc_chat_layout');
        if (existingChatLayout) existingChatLayout.remove();
        document.body.appendChild(chatLayout);
      }
      if (cbActions) {
        const existingCbActions = document.getElementById('lc_cb_actions_vi');
        if (existingCbActions) existingCbActions.remove();
        document.body.appendChild(cbActions);
      }
    };

    document.addEventListener('turbo:visit', saveLiveChatElements);
    document.addEventListener('turbolinks:render', restoreLiveChatElements);
  })();
}
